import { Toast, ToastViewport } from '@lualtek/react-components';
import { domMax, LazyMotion } from 'motion/react';
import useTranslation from 'next-translate/useTranslation';
import { Ref, useEffect } from 'react';

import { useFeedbackContext } from '@/context/use-feedback-context';
import { useMobileContext } from '@/context/use-mobile-context';

import { CommonLayoutType } from '../../types';
import styles from './base-layout.module.css';

export const BaseLayout: CommonLayoutType = ({ children }) => {
  const { feedbacks, resetFeedbacks } = useFeedbackContext();
  const { isMobile } = useMobileContext();
  const { t } = useTranslation();

  // Reset feedback when changing layout
  useEffect(() => () => resetFeedbacks(), [resetFeedbacks]);

  return (
    <>
      <LazyMotion features={domMax}>
        {children}
      </LazyMotion>

      {feedbacks.map(({ id, ref, ...rest }) => (
        <Toast
          key={id}
          dismissable
          ref={ref as Ref<HTMLLIElement>}
          dismissLabel={t('common:cta.dismiss')}
          {...rest}
        />
      ))}

      <svg width="0" height="0" style={{ position: 'absolute', pointerEvents: 'none' }} version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="DawnGradient" x1="0.12" y1="0.18" x2="0.88" y2="0.82">
            <stop offset="0%" stopColor="var(--gradient-dawn-start)" />
            <stop offset="100%" stopColor="var(--gradient-dawn-end)" />
          </linearGradient>
        </defs>
      </svg>

      <ToastViewport className={styles.ToastViewport} data-is-mobile={isMobile} />
    </>
  );
};

